import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ChangeSavedSearchVisibilityProps as Props } from './types';
import { Stack, Switch, Typography } from '@mui/material';
import { Icon } from '@aibees/shared/components';
import { PresetVisibility } from '@aibees/shared/definition';

export const ChangeSavedSearchVisibility = memo(
  ({ className, onChange, visibility }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('ChangeSavedSearchVisibility', className)}
        sx={SX.root}
      >
        <Stack direction="row" alignItems="center" gap={0.5}>
          <Icon name="lock-rounded" sxx={SX.icon} size={18} />
          <Typography sx={SX.text}>Private</Typography>
        </Stack>

        <Switch
          sx={SX.checkSwitch}
          size="medium"
          onChange={onChange}
          checked={visibility === PresetVisibility.PRIVATE}
        />
      </Styled.Wrapper>
    );
  }
);

ChangeSavedSearchVisibility.displayName = 'ChangeSavedSearchVisibility';
